import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QuestionAnswer, TopicAnswers } from '@app/_models';
import { CourseService } from '@app/_services/course.service';
import { TopicShareService } from '@app/_services/topic.share.service';
import { first } from 'rxjs/operators';

@Component({ templateUrl: 'peb-topic.component.html', selector: 'peb-topic' })
export class PEBTopicComponent {

    loading = false;
    sectionId: any;
    topic: any;
    theme: string = 'light';
    pebcontent: any;
    topicAnswers: TopicAnswers;
    assessmentId: number;
    assessmentAnswerId: number;

    seededTitleActive: boolean;
    sproutingTitleActive: boolean;
    bloomingTitleActive: boolean;
    fullBloomTitleActive: boolean;

    constructor(private route: ActivatedRoute, private courseService: CourseService, private shareService: TopicShareService) { }

    ngOnInit() {

        this.topicAnswers = new TopicAnswers();

        this.route.paramMap.subscribe(params => {
            this.sectionId = params.get('id');

            this.seededTitleActive = false;
            this.sproutingTitleActive = false;
            this.bloomingTitleActive = false;
            this.fullBloomTitleActive = false;

            this.getTopic();
        });
    }

    get nonAssessmentAnswers() {
        if (this.topicAnswers.answers)
            return this.topicAnswers.answers.filter(a => !a.assessmentId);
        return [];
    }

    getTopic() {
        this.courseService.getTopic(this.sectionId).pipe(first()).subscribe(data => {
            this.loading = false;

            this.topic = data.section;
            this.topic.principleNumber = data.principleNumber;

            this.theme = data.theme.toLowerCase();

            let contentTitle = this.topic.contents.find(c => c.discriminator == "HtmlText");
            let imagesWithText = this.topic.contents.filter(c => c.discriminator == "ImageAndText");
            this.pebcontent = { title: contentTitle, imagesWithText: imagesWithText };
            this.topicAnswers = new TopicAnswers();
            this.topicAnswers.topicId = this.topic.id;

            this.topicAnswers.answers = this.topic.questions.map(q => {

                var questionAnswer = new QuestionAnswer();
                questionAnswer.questionText = q.questionText;
                questionAnswer.placeholder = q.placeholder;
                questionAnswer.questionId = q.id;

                var answerResult = data.answers.find(a => {
                    return a.question.id == q.id;
                });

                if (answerResult) {
                    questionAnswer.answer = answerResult.answer;
                    questionAnswer.answerId = answerResult.answerId;
                } else {
                    questionAnswer.answerId = 0;
                }

                return questionAnswer;
            });

            let assessmentAnswer = data.answers.filter(a => a.assessment)[0];
            if (assessmentAnswer) {
                this.assessmentAnswerId = assessmentAnswer.answerId;
                this.markAssessmentAnswerAsActive(assessmentAnswer.answer, assessmentAnswer.assessment.id);
                this.assessmentAnswer(assessmentAnswer.answer, assessmentAnswer.assessment.id);
            }    

            this.shareService.emitter.emit(this.isValidSection());
        });
    }

    markAssessmentAnswerAsActive(assessmentAnswer, assessmentId) {

        let assessmentAnswered = this.topic.assessments.filter(a => a.id == assessmentId)[0]; 

        if (assessmentAnswer == assessmentAnswered.seededTitle) {
            this.seededTitleActive = true;
            this.sproutingTitleActive = false;
            this.bloomingTitleActive = false;
            this.fullBloomTitleActive = false;
        }

        if (assessmentAnswer == assessmentAnswered.sproutingTitle) {
            this.seededTitleActive = false;
            this.sproutingTitleActive = true;
            this.bloomingTitleActive = false;
            this.fullBloomTitleActive = false;
        }

        if (assessmentAnswer == assessmentAnswered.bloomingTitle) {
            this.seededTitleActive = false;
            this.sproutingTitleActive = false;
            this.bloomingTitleActive = true;
            this.fullBloomTitleActive = false;
        }

        if (assessmentAnswer == assessmentAnswered.fullBloomTitle) {
            this.seededTitleActive = false;
            this.sproutingTitleActive = false;
            this.bloomingTitleActive = false;
            this.fullBloomTitleActive = true;
        }
    }

    assessmentAnswer(answerText, assessmentId) {

        this.markAssessmentAnswerAsActive(answerText, assessmentId);

        var answerAssessment = this.topicAnswers.answers.find(a => a.assessmentId > 0);

        if (answerAssessment) {
            answerAssessment.answer = answerText;
        } else {
            var questionAnswer = new QuestionAnswer();
            questionAnswer.assessmentId = assessmentId;
            questionAnswer.answer = answerText;
            questionAnswer.answerId = this.assessmentAnswerId;
            this.topicAnswers.answers.push(questionAnswer);
        }

        this.shareService.emitter.emit(this.isValidSection());
    }

    answerChanged(answer, answerId, index) {
        
        if (answerId == 0) {
            this.topicAnswers.answers[index].answer = answer.answer.target.value;
        } else {
            this.topicAnswers.answers.find(a => a.answerId == answerId).answer =  answer.answer.target.value;
        }

        this.shareService.emitter.emit(this.isValidSection());
    }

    isValidSection() {
        if(this.topicAnswers.answers) {
            
            let normalAnswers = this.topicAnswers.answers.filter( a => !a.assessmentId);
            let hasAssessmentAnswer = this.topicAnswers.answers.filter( a => a.assessmentId);
            
            if(this.topic.questions.length > 0 && normalAnswers.length == this.topic.questions.length && hasAssessmentAnswer.length>0) {
                for(var i=0; i<this.topicAnswers.answers.length; i++) {
                
                    if(this.topicAnswers.answers[i]){
                        if(this.topicAnswers.answers[i].answer == undefined || this.topicAnswers.answers[i].answer.trim() == ""){
                            return false;
                        }
                    } else {
                        return false;
                    }
                }
                
                return true;
            } else {
                return false;
            }

        } else {
            return true;
        }
    }

    save() {
        if (this.topicAnswers && this.topicAnswers.answers && this.topicAnswers.answers.length > 0)
            return this.courseService.postAnswers(this.sectionId, this.topicAnswers);
        else
            return this.courseService.addProgress(this.sectionId);
    }
}